module.exports = __webpack_public_path__ + "static/media/Beowulf.d086b6b8.png";